import React from "react";
import PaymentForm from "./PaymentForm";
import {
  Create,
  Edit,
  LongTextInput,
  SelectInput,
  BooleanInput,
  ImageField
} from "admin-on-rest";
import IconTitle from "../components/icon_title";
import { paymentDefaultValue, typePayment, validatePayment } from './defaultValues';
import ImageOlaSingleInput from "../components/image";
import DependentImageInput from "../components/image/DependentImageInput";

const PaymentCRUDForm = ({ ...props, permissions }) => ( 
    <PaymentForm
      {...props}
      defaultValue={paymentDefaultValue}
      validate={validatePayment}
      >
      <LongTextInput label="resources.payments.field.bankName" source="name" />  
      <BooleanInput label="resources.payments.field.active" source="active" />  
      <SelectInput label="resources.payments.field.type" source="type" choices={typePayment}/>
      <DependentImageInput dependsOn={"name"} {...props}>
      <ImageOlaSingleInput
        source="logo"
        toValue={props.toValue}
        labelImage="Logo (120x120)"
        label={"resources.payments.field.logo"}
        accept="image/*"
      >
        <ImageField source="src" title="title" />
      </ImageOlaSingleInput>
    </DependentImageInput>
  </PaymentForm>);

export const PaymentCreate = props => (
  <Create
    {...props}
    title={<IconTitle icon="payments" title={"resources.payments.titleNew"} />}
  >
    {permissions => <PaymentCRUDForm {...props} permissions={permissions} />}
  </Create>
);

export const PaymentEdit = props => (
  <Edit
    {...props}
    title={<IconTitle icon="payments" title={"resources.payments.titleEdit"} />}
  >
    {permissions => <PaymentCRUDForm {...props} permissions={permissions} />}
  </Edit>
);



// WEBPACK FOOTER //
// ./src/payment/Detail.js